// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const CopyToClipboardIcon = ({ copied, onClick }) => (
  <Icon
    data-testid="copyable-toast-content-icon"
    name={copied ? 'check' : 'copy outline'}
    onClick={onClick}
    style={{ cursor: 'pointer' }}
    title={copied ? 'Copied!' : 'Copy to clipboard'}
  />
);
